import { useEffect } from "react";
import { Toaster, toast } from "@jana-technology/platform-ui";
import { RISK_ASSET_FILTERS_NO_RESULTS_MESSAGE } from "constants/charts";

export type HierarchyIdToasterProps = {
  selectedHierarchyIdsLength: number;
  submitDisabled: boolean;
  wellNamesGroupedByHierarchy?: Array<{
    hierarchyId?: number | null;
    wellNames?: Array<string>;
  }>;
  children: React.ReactNode;
};

export const HierarchyIdToaster = ({
  selectedHierarchyIdsLength,
  submitDisabled,
  wellNamesGroupedByHierarchy,
  children,
}: HierarchyIdToasterProps) => {
  useEffect(() => {
    if (selectedHierarchyIdsLength && submitDisabled) {
      // toast needs a timer and a close method to prevent multiple toasts from stacking up
      toast.warning("Please select at least one field");
    }
  }, [selectedHierarchyIdsLength, submitDisabled]);

  useEffect(() => {
    if (wellNamesGroupedByHierarchy?.length === 0) {
      toast.warning(RISK_ASSET_FILTERS_NO_RESULTS_MESSAGE);
    }
  }, [wellNamesGroupedByHierarchy]);

  return (
    <>
      {children}
      <Toaster />
    </>
  );
};
